import Image from "next/image";
import React from "react";

interface ToolbarWithBackButtonProps {
  onBack?: () => void;
}

const ToolbarWithBackButton: React.FC<ToolbarWithBackButtonProps> = ({
  onBack,
}) => {
  return (
    <div className="px-3.5 py-2.5 flex items-center">
      <button
        onClick={onBack}
        className="flex items-center text-ng-main"
        aria-label="Go back"
      >
        <Image
          className="w-4 h-auto"
          src="/icons/left.png"
          alt="Back"
          width={16}
          height={16}
        />
        <span className="ml-3 text-sm">戻る</span>
      </button>
    </div>
  );
};

export default ToolbarWithBackButton;
